import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: { main: "#24582A", dark: "#17371A", contrastText: "#FFFAF1" },
        secondary: { main: "#24582A", dark: "#17371A", contrastText: "#FFFAF1" },
        background: { default: "#FFFAF1", paper: "#D4E9CF" },
        text: {
            primary: "#052812",
            secondary: "#17371A",
            inverse: "#FFFAF1",
        },
        neutral: {
            main: "#D4E9CF",
            dark: "#17371A",
        },
        section: {
            bg: "#D4E9CF",
            border: "#24582A",
        },
        filter: {
            bg: "#D4E9CF",
            bgSelected: "#FFFAF1",
            border: "#24582A",
            borderSelected: "#17371A",
        },
    },

    typography: {
        fontFamily:
            '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
        h1: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
        h2: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
        h3: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
        h4: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
        h5: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
        h6: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
    },

    shape: { borderRadius: 8 },

    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    borderRadius: 8,
                    fontFamily:
                        '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
                },
            },
        },

        MuiLink: {
            styleOverrides: {
                root: {
                    color: "#24582A",
                    textDecorationColor: "#24582A",
                    "&:hover": {
                        color: "#17371A",
                        textDecorationColor: "#17371A",
                    },
                },
            },
        },

        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: "#24582A",
                },
            },
        },

        MuiTab: {
            styleOverrides: {
                root: {
                    color: "#052812",
                    "&.Mui-selected": {
                        color: "#24582A",
                    },
                },
            },
        },

        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: "#24582A",
                    "&.Mui-checked": {
                        color: "#17371A",
                    },
                },
            },
        },

        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderRadius: 8,
                    backgroundColor: "#FFFAF1",
                    border: "1px solid #D4E9CF",
                },
            },
        },

        MuiMenuItem: {
            styleOverrides: {
                root: {
                    color: "#052812",
                    backgroundColor: "#FFFAF1",

                    "&:hover": {
                        backgroundColor: "#D4E9CF",
                    },

                    "&.Mui-selected": {
                        backgroundColor: "#D4E9CF !important",
                        color: "#052812",
                    },

                    "&.Mui-selected:hover": {
                        backgroundColor: "#C6DEBF !important",
                    },

                    "&.Mui-focusVisible": {
                        backgroundColor: "#D4E9CF !important",
                    },
                },
            },
        },

        MuiList: {
            styleOverrides: {
                root: {
                    "& .Mui-selected": {
                        backgroundColor: "#D4E9CF !important",
                        color: "#052812",
                    },

                    "& .Mui-focusVisible": {
                        backgroundColor: "#D4E9CF !important",
                    },
                },
            },
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: "#FFFAF1",
                },
            },
        },

        MuiTextField: {
            defaultProps: {
                variant: "outlined",
            },
        },

        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: "#052812",

                    "&.Mui-focused": {
                        color: "#17371A",
                    },

                    "&.Mui-error": {
                        color: "#17371A",
                    },
                },
            },
        },

        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    color: "#24582A",

                    "&.Mui-error": {
                        color: "#24582A",
                    },
                },
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "#D4E9CF",
                    borderRadius: 8,
                    color: "#052812",

                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#24582A",
                    },

                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#17371A",
                    },

                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#17371A",
                        borderWidth: 2,
                    },

                    "&.Mui-error": {
                        backgroundColor: "#D4E9CF",
                    },

                    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#24582A",
                    },

                    "& input:-webkit-autofill": {
                        WebkitBoxShadow:
                            "0 0 0 100px #D4E9CF inset",
                        WebkitTextFillColor:
                            "#052812",
                        caretColor: "#052812",
                        borderRadius: 8,
                    },
                },

                input: {
                    color: "#052812",
                },
            },
        },

        MuiSelect: {
            styleOverrides: {
                select: {
                    color: "#052812",
                    backgroundColor: "#D4E9CF",
                },

                icon: {
                    color: "#052812",
                },
            },
        },
    },
});

export default theme;